import { render, staticRenderFns } from "./grid-tasks.vue?vue&type=template&id=4f52169c"
import script from "./grid-tasks.ts?vue&type=script&lang=js&external"
export * from "./grid-tasks.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports